import { View } from 'react-native'
import { Text } from '@/components/ui/Text'
import { useThemeColors } from '@/contexts/ThemeContext'
import { colors as staticColors } from '@/theme'

export function getInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase()
}

export function relativeTime(isoString: string): string {
  const diff = Date.now() - new Date(isoString).getTime()
  const minutes = Math.floor(diff / 60_000)
  if (minutes < 60) return `${minutes}m`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h`
  const days = Math.floor(hours / 24)
  return `${days}d`
}

type AvatarSize = 'sm' | 'md'

type AvatarProps = {
  initials: string
  size?: AvatarSize
}

export function CommunityAvatar({ initials, size = 'md' }: AvatarProps) {
  const colors = useThemeColors()
  const dimension = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10'
  const textSize = size === 'sm' ? 'text-[11px]' : 'text-xs'
  return (
    <View
      className={`${dimension} rounded-full items-center justify-center`}
      style={{ backgroundColor: staticColors.primary }}
    >
      <Text
        className={`${textSize} font-medium native:font-medium`}
        style={{ color: colors.white }}
      >
        {initials}
      </Text>
    </View>
  )
}
